import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Córdoba'
}, {
  name: 'Lucas',
  city: 'Buenos Aires'
}, {
  name: 'Valentina',
  city: 'Rosario'
}, {
  name: 'Santiago',
  city: 'Mendoza'
}, {
  name: 'Camila',
  city: 'La Plata'
}, {
  name: 'Martín',
  city: 'Tucumán'
}, {
  name: 'Sofía',
  city: 'Mar del Plata'
}, {
  name: 'Mateo',
  city: 'Salta'
}, {
  name: 'Isabella',
  city: 'Santa Fe'
}, {
  name: 'Joaquín',
  city: 'Neuquén'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      // Pick a random buyer
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      // Hide after 4 seconds
      timeoutId = setTimeout(() => {
        setIsVisible(false);
        // Schedule next popup between 8-12 seconds
        const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
        timeoutId = setTimeout(showPopup, nextInterval);
      }, 4000);
    };
    // Initial delay before first popup
    timeoutId = setTimeout(showPopup, 5000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-100 p-4 max-w-xs transform transition-all duration-500 ease-in-out flex items-center gap-3 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'}`} data-id="element-311">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-312">
        <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-313" />
      </div>
      <div data-id="element-314">
        <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-315">
          <span className="font-bold" data-id="element-316">{currentBuyer.name}</span> de{' '}
          {currentBuyer.city} acaba de comprar este libro digital
        </p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-317">Hace unos momentos</p>
      </div>
    </div>;
}